import CoreUtils from './CoreUtils';

export const spaceCharCode = 32;
export const hyphenCharCode = 45;

export default class StringUtils {
  static isNullOrEmpty(value) {
    return CoreUtils.isUndefinedOrNull(value) || value === '';
  }

  static isValidString(value) {
    return CoreUtils.isDefinedAndNotNull(value)
      && typeof value === 'string';
  }

  static isNonEmptyString(value) {
    if (CoreUtils.isUndefinedOrNull(value) || typeof value !== 'string')
      return false;

    return value.length > 0;
  }

  static isEmptyString(value) {
    return value === '';
  }

  static isStringArray(values) {
    return CoreUtils.isDefinedAndNotNull(values) && Array.isArray(values)
      && values.every(value => StringUtils.isValidString(value));
  }

  static sortStringArray(stringArray, useCaseInsensitiveSort) {
    if (!StringUtils.isStringArray(stringArray))
      return stringArray;

    var options = {};
    if (useCaseInsensitiveSort)
      options.sensitivity = 'base';

    return stringArray.toSorted(
      (a, b) => a.localeCompare(b, 'en', options)
    );
  }

  static isNullOrWhitespace(value) {
    if (CoreUtils.isUndefinedOrNull(value) || typeof value !== 'string')
      return true;

    value = value.trim();
    return value.length === 0;
  }

  static split(value, delimiters, trimValues) {
    if (!StringUtils.isValidString(value))
      return [];

    if (StringUtils.isValidString(delimiters)) {
      if (delimiters.length !== 1)
        return [];
      else
        delimiters = [delimiters];
    } else if (!StringUtils.isStringArray(delimiters)
      || delimiters.some(delimiter => delimiter.length !== 1))
      return [];

    var stringArray = [];
    var stringFragment = '';
    for (var index = 0; index < value.length; index += 1) {
      var character = value[index];
      switch (character) {
        case ';':
        case ',':
          StringUtils.processFragment(stringFragment, stringArray, trimValues);
          stringFragment = '';
          break;
        default:
          stringFragment += character;
          break;
      }
    }

    StringUtils.processFragment(stringFragment, stringArray, trimValues);

    return stringArray;
  }

  static processFragment(stringValue, stringArray, trimValues) {
    if (trimValues)
      stringValue = stringValue.trim();

    if (stringValue.length > 0)
      stringArray.push(stringValue);
  }

  static join(values, delimiter) {
    if (!StringUtils.isStringArray(values))
      return '';

    var result = '';
    values.forEach((value, index) => {
      if (index !== 0)
        result += delimiter;
      result += value.trim();
    });

    return result;
  }

  static isAlphaNumericString(value, allowSpaces, allowHyphens) {
    if (CoreUtils.isUndefinedOrNull(value) || typeof value !== 'string')
      return false;

    for (var index = 0; index < value.length; index++) {
      var charCode = value.charCodeAt(index);
      if (!StringUtils.isAlphanumericCharacter(charCode, allowSpaces, allowHyphens))
        return false;
    }

    return true;
  }

  static indexOfCharCode(value, charCode) {
    if (CoreUtils.isUndefinedOrNull(value) || typeof value !== 'string')
      return false;

    for (var index = 0; index < value.length; index++) {
      if (value.charCodeAt(index) === charCode)
        return index;
    }

    return -1;
  }

  static isAlphanumericCharacter(charCode, allowSpaces, allowHyphens) {
    return (charCode >= 48 && charCode <= 57)
      || (charCode >= 65 && charCode <= 90)
      || (charCode >= 97 && charCode <= 122)
      || (allowSpaces && charCode === spaceCharCode)
      || (allowHyphens && charCode === hyphenCharCode);
  }
}